import {setConversationSubject} from '../../../helpers/models/conversationHelpers';
import {updateConversationsAction} from './updateConversationsActions';

export function updateConversationSubjectAction(conversationIds: ReadonlyArray<number>, subject: string) {
  return updateConversationsAction(conversationIds, {subject}, setConversationSubject(subject));
}
